/**
 * Vite 構建的入口。
 *
 * 這個檔案承擔兩件事：
 *
 * 1. **順序**：Expo 的 web 全局量必須在任何業務 import 之前裝好。
 * 2. **分包**：i18n 必須在任何模組層級的 `t` 調用之前初始化。Rolldown 會把
 *    App 的模組圖拆成獨立 chunk，chunk 先於入口本體求值；路由表這類檔案在
 *    模組層級就調用 `t`，入口若靜態 import App，會先拋
 *    「without setting a locale」。所以 App 改成動態 import：入口本體先完成
 *    i18n 初始化，再開始加載 App。
 *
 * `src/index.js` 本身不動 —— 那份檔案 Metro 也要用。
 */
import '@dp-frontend/expo-vite/web-globals';
import './src/i18n';

import('./src/entry').catch((error) => {
  // 這裡是應用的最外層，啟動失敗沒有別的地方能報
  console.error('[vite-entry] 應用啟動失敗', error);
});
